import { v4 as uuidv4 } from "uuid";

export const generateClientSeed = () => {
  return Math.random().toString(36).substring(2);
};

export const generateUuid = () => {
  return uuidv4();
};

export function generateNextClientSeed(length = 12): string {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_";
  let seed = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    seed += characters[randomIndex];
  }
  return seed;
}

export function convertImageUrl(url: string) {
  if (url.includes("barbarabang.io")) {
    const newUrl = url.replace(
      "https://games-static.barbarabang.io/uploads/promo/icons",
      "https://sharkroll-casino-prod.s3.eu-west-1.amazonaws.com/barbarabang",
    );

    return newUrl;
  }

  return url;
}
